export const ConfigMantenedorAlerta = {
   barraBusqueda: {
      criterios: ["Nombre"],
      criteriosKeys: ["nombre"],
      criterioPrincipal: "Nombre",
   },
   table: {
      title: "Mantenedor Alerta",
      add: "Carga Documento",
      options: [
         {
            name: "Importar",
            active: true,
            class: "ft-upload",
         },
         {
            name: "Exportar",
            active: true,
            class: "ft-download",
         },
         {
            name: "Solicitar Soporte",
            active: true,
            class: "ft-shuffle",
         },
      ],
   },
};
